import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Link } from "react-router-dom";
import { Queries, Mutations } from "../../../../../graphql";
import PropTypes from "prop-types";
import {
  Tabs,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  message,
  Table,
  Icon,
  Button,
  Popconfirm,
  Form,
  Select,
  Radio,
  DatePicker,
  Avatar,
  Modal,
  InputNumber,
  TimePicker,
  Checkbox,
} from "antd";
import moment from "moment";
import FromInput from "../../../../../components/user/from/Input";
import {
  changeFormatdate,
  changeFormatFulldate,
} from "../../../../../utils/formatdate";

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const DOCUMENT_TYPE = [
  { label: "ใบรับรองแพทย์", value: "ใบรับรองแพทย์" },
  //  { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
  { label: "อื่น ๆ", value: "อื่น ๆ" },
];

const newsDataProfile = "";
const format = "HH:mm";

class Tab1 extends Component {
  state = {
    dataTalbeUploads: [
      {
        documentType: null,
        description: null,
        attachFile: null,
        statusFile: false,
      },
    ],
    columns: [
      {
        title: "ลำดับ",
        dataIndex: "description",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* {this.props.detailForm?.studyScholarship.studyScholarshipDetail[index].studyScholarshipDetailSort} */}
              {index + 1}
            </>
          );
        },
      },

      {
        title: "วันที่รายงานตัวกลับเข้าปฏิบัติงาน",
        dataIndex: "studyReturnDate",
        align: "center",
        width: "250px",
        vertical: "top",
        render: (item, record, index) => {
          return (
            <>
              {/* <Form.Item className="mb-0" style={{ marginBottom: "0px" }}>
            {this.props.form.getFieldDecorator("studyReturnDate", {
              initialValue: moment(
                record?.studyReturnDate
              ),
                 rules:  [{
                    required:true,
                    message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
                 }],
            })(
              <DatePicker
                format={this.dateFormatNumber("studyReturnDate")}
                placeholder=""
                style={{ width: "100%" }}
                disabled={true}
              />
            )}
          </Form.Item> */}
              {changeFormatdate(item)}
            </>
          );
        },
      },
      {
        title: "เลขที่คำสั่งกลับ",
        dataIndex: "studyReturnDocument",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {item}
              {/* <FromInput
                disabled={true}
                value={
                  record?.studyReturnDocument
                }
                required={false}
                name={"studyReturnDocument"}
                mode={"text"}
              /> */}
            </>
          );
        },
      },
      {
        title: "ลงวันที่เลขที่คำสั่งกลับ",
        dataIndex: "studyReturnDocumentDate",
        width: "250px",
        vertical: "top",
        align: "center",
        render: (item, record, index) => {
          return (
            <>
              {/* <Form.Item className="mb-0" style={{ marginBottom: "0px" }}>
            {this.props.form.getFieldDecorator("studyReturnDocumentDate", {
              initialValue: moment(
                record?.studyReturnDocumentDate
              ),
              //    rules:  [{
              //       required:true,
              //       message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
              //    }],
            })(
              <DatePicker
                format={this.dateFormatNumber("studyReturnDocumentDate")}
                placeholder=""
                style={{ width: "100%" }}
                disabled={true}
              />
            )}
          </Form.Item> */}
              {changeFormatdate(item)}
            </>
          );
        },
      },
    ],
  };

  dateFormatNumber = (values) => {
    let valueReturn = this.props.form.getFieldValue(values);
    return changeFormatdate(moment(valueReturn));
  };

  render() {
    const { match, detailForm } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { columns } = this.state;

    console.log("detailForm Tab1", detailForm);

    return (
      <Row gutter={16} type="flex" justify="left" align="top">
        <Col xs={24} md={24} className="pt-0">
          <strong className="color-red">ข้อมูลการลา</strong>
        </Col>
        <Col xs={24} md={12} className="pt-2 mb-2">
          <Form.Item label={"ระดับการศึกษา"} style={{ marginBottom: "0px" }}>
            <Select
              disabled={true}
              style={{ width: "100%" }}
              value={detailForm?.studyLeaveDetail[0].studyLeaveDegree}
              // onChange={ (e) => this.onChangeHospitalDetail(e) }
            ></Select>
            {/* )
                } */}
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-2 mb-2">
          <Form.Item label={"หลักสูตร"} style={{ marginBottom: "0px" }}>
            {
              // getFieldDecorator("hospitalName", {
              //     initialValue: "",
              //     rules:  [{
              //         required: true,
              //         message: 'กรุณาระบุ ชื่อสถานพยาบาล',
              //     }],
              // })(
              <Select
                disabled={true}
                style={{ width: "100%" }}
                value={detailForm?.studyLeaveDetail[0].studyLeaveCourse}
                // onChange={ (e) => this.onChangeHospitalDetail(e) }
              ></Select>
              // )
            }
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"วุฒิการศึกษา"} style={{ marginBottom: "0px" }}>
            {
              // getFieldDecorator("hospitalName", {
              //     initialValue: "",
              //     rules:  [{
              //         required: true,
              //         message: 'กรุณาระบุ ชื่อสถานพยาบาล',
              //     }],
              // })(
              <Select
                disabled={true}
                style={{ width: "100%" }}
                value={detailForm?.studyLeaveDetail[0].studyLeaveEducational}
                // onChange={ (e) => this.onChangeHospitalDetail(e) }
              ></Select>
              // )
            }
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"สาขาวิชา"} style={{ marginBottom: "0px" }}>
            {
              // getFieldDecorator("hospitalName", {
              //     initialValue: "",
              //     rules:  [{
              //         required: true,
              //         message: 'กรุณาระบุ ชื่อสถานพยาบาล',
              //     }],
              // })(
              <Select
                disabled={true}
                value={detailForm?.studyLeaveDetail[0].studyLeaveMajor}
                style={{ width: "100%" }}
                // onChange={ (e) => this.onChangeHospitalDetail(e) }
              ></Select>
              // )
            }
          </Form.Item>
        </Col>{" "}
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"ประเทศ"} style={{ marginBottom: "0px" }}>
            {
              // getFieldDecorator("hospitalName", {
              //     initialValue: "",
              //     rules:  [{
              //         required: true,
              //         message: 'กรุณาระบุ ชื่อสถานพยาบาล',
              //     }],
              // })(
              <Select
                disabled={true}
                style={{ width: "100%" }}
                value={detailForm?.studyLeaveDetail[0].studyLeaveCountry}
                // onChange={ (e) => this.onChangeHospitalDetail(e) }
              ></Select>
              // )
            }
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          {console.log(
            "detailForm?.studyLeaveDetail[0].studyLeaveCountry.includes",
            detailForm?.studyLeaveDetail[0].studyLeaveCountry.includes("ไทย")
          )}
          <FromInput
            disabled={true}
            value={
              detailForm?.studyLeaveDetail[0].studyLeaveCountry.includes("ไทย")
                ? "ในประเทศ"
                : "ต่างประเทศ"
            }
            required={false}
            name={"studyLeaveCountry2"}
            label="ในประเทศ หรือ ต่างประเทศ"
            mode={"text"}
          />
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"สถาบันการศึกษา"} style={{ marginBottom: "0px" }}>
            {
              // getFieldDecorator("hospitalName", {
              //     initialValue: "",
              //     rules:  [{
              //         required: true,
              //         message: 'กรุณาระบุ ชื่อสถานพยาบาล',
              //     }],
              // })(
              <Select
                disabled={true}
                style={{ width: "100%" }}
                value={detailForm?.studyLeaveDetail[0].studyLeaveAcademy}
                // onChange={ (e) => this.onChangeHospitalDetail(e) }
              ></Select>
              // )
            }
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <FromInput
            disabled={true}
            value={detailForm?.studyLeaveDetail[0].studyLeaveStrategyYear}
            required={false}
            name={"studyLeaveStrategyYear"}
            label="ปีการศึกษา"
            mode={"text"}
          />
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item
            label={"วันที่เริ่มต้นลาศึกษา"}
            className="mb-0"
            style={{ marginBottom: "0px" }}
          >
            {getFieldDecorator("studyLeaveStartDate", {
              initialValue: moment(
                detailForm?.studyLeaveDetail[0].studyLeaveStartDate
              ),
              //    rules:  [{
              //       required:true,
              //       message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
              //    }],
            })(
              <DatePicker
                format={this.dateFormatNumber("studyLeaveStartDate")}
                placeholder=""
                style={{ width: "100%" }}
                disabled={true}
              />
            )}
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item
            label={"วันที่สิ้นสุดการศึกษา"}
            style={{ marginBottom: "0px" }}
          >
            {getFieldDecorator("studyLeaveEndDate", {
              initialValue: moment(
                detailForm?.studyLeaveDetail[0].studyLeaveEndDate
              ),
              //    rules:  [{
              //       required:true,
              //       message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
              //    }],
            })(
              <DatePicker
                format={this.dateFormatNumber("studyLeaveEndDate")}
                placeholder=""
                style={{ width: "100%" }}
                disabled={true}
              />
            )}
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"ระยะเวลาหลักสูตร"} className="mb-0">
            <Form
              labelCol={{ offset: 0, span: "100px", push: 1 }}
              wrapperCol={{
                offset: 0,
                span: 18,
                xl: { span: 14 },
                xxl: { span: 17 },
              }}
              colon={false}
            >
              <Row gutter={4} type="flex" justify="left" align="top">
                <Col span={24} xl={8}>
                  <Form.Item label="ปี" className="m-0">
                    {getFieldDecorator("studyLeaveDurationYear", {
                      initialValue:
                        detailForm?.studyLeaveDetail[0]
                          ?.studyLeaveDurationYear || "-",
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>
                <Col span={24} xl={8}>
                  <Form.Item label="เดือน" className="m-0">
                    {getFieldDecorator("studyLeaveDurationMonth", {
                      initialValue:
                        detailForm?.studyLeaveDetail[0]
                          ?.studyLeaveDurationMonth || "-",
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>
                <Col span={24} xl={8}>
                  <Form.Item label="วัน" className="m-0">
                    {getFieldDecorator("studyLeaveDurationDay", {
                      initialValue:
                        detailForm?.studyLeaveDetail[0]
                          ?.studyLeaveDurationDay || "-",
                    })(<Input disabled={true} />)}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"จำนวนวันที่ลาศึกษา (วัน)"} className="mb-0">
            {getFieldDecorator("studyLeaveDurationDay", {
              initialValue:
                detailForm?.studyLeaveDetail[0]?.studyLeaveDuration || "-",
            })(<Input disabled={true} />)}
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item label={"ลักษณะการลา"} style={{ marginBottom: "0px" }}>
            {
              // getFieldDecorator("hospitalName", {
              //     initialValue: "",
              //     rules:  [{
              //         required: true,
              //         message: 'กรุณาระบุ ชื่อสถานพยาบาล',
              //     }],
              // })(
              <Select
                disabled={true}
                style={{ width: "100%" }}
                value={detailForm?.studyLeaveDetail[0].studyLeaveType}
                // onChange={ (e) => this.onChangeHospitalDetail(e) }
              ></Select>
              // )
            }
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          <Form.Item
            label={"ต้องตีพิมพ์งานวิจัย"}
            valuePropName={"checked"}
            style={{ marginBottom: "0px" }}
          >
            <Checkbox
              checked={detailForm?.studyLeaveDetail[0].isPublishJournal}
              value={detailForm?.studyLeaveDetail[0].isPublishJournal}
              disabled={true}
            ></Checkbox>
          </Form.Item>
        </Col>
        {detailForm?.studyReturnDetail.length > 0 && (
          <>
            <Col xs={24} md={24} className="mt-4">
              <strong className="color-red">ข้อมูลรายงานตัวกลับ</strong>
            </Col>
            <Col xs={24} md={24} align={"right"} className="pt-4">
              <Table
                columns={columns}
                dataSource={detailForm?.studyReturnDetail}
                pagination={false}
                className="mb-3"
                bordered
                rowCount={
                  detailForm?.studyScholarship.studyScholarshipDetail.length
                }
                locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
                // pagination={{ pageSize: dataTalbeUploads.length }}
              />
            </Col>
          </>
        )}
        <Col xs={24} md={12} className="mb-2">
          {/* <Form.Item
            label={"วันที่รายงานตัวกลับเข้าปฏิบัติงาน"}
            style={{ marginBottom: "0px" }}
          >
            {getFieldDecorator("studyLeaveReturnDate", {
              initialValue: detailForm?.studyLeaveDetail[0].studyLeaveReturnDate
              ? moment(
                detailForm?.studyLeaveDetail[0].studyLeaveReturnDate
              ) : "",
              //    rules:  [{
              //       required:true,
              //       message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
              //    }],
            })(
              <DatePicker
                format={this.dateFormatNumber("studyLeaveReturnDate")}
                placeholder=""
                style={{ width: "100%" }}
                disabled={true}
              />
            )}
          </Form.Item> */}
          {/* <FromInput
            disabled={true}
            value={detailForm?.studyLeaveDetail[0].studyLeaveReturnDate ? changeFormatdate(detailForm?.studyLeaveDetail[0].studyLeaveReturnDate) : "-"}
            required={false}
            name={"studyLeaveReturnDate"}
            label="วันที่รายงานตัวกลับเข้าปฏิบัติงาน"
            mode={"text"}
          /> */}
        </Col>
        <Col xs={24} md={12} className=" mb-2">
          {/* <FromInput
            disabled={true}
            value={detailForm?.studyLeaveDetail[0].studyLeaveReturnDocument ? detailForm?.studyLeaveDetail[0].studyLeaveReturnDocument : "-"}
            required={false}
            name={"studyLeaveReturnDocument"}
            label="เลขที่คำสั่งกลับ"
            mode={"text"}
          /> */}
        </Col>
        <Col xs={24} md={12} className="pt-0 mb-2">
          {/* <Form.Item label={"ลงวันที่เลขที่คำสั่งกลับ"} style={{ marginBottom: "0px" }}>
            {getFieldDecorator("studyLeaveReturnDocumentDate", {
              initialValue: detailForm?.studyLeaveDetail[0].studyLeaveReturnDocumentDate ? moment(
                detailForm?.studyLeaveDetail[0].studyLeaveReturnDocumentDate
              ) : "",
              //    rules:  [{
              //       required:true,
              //       message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
              //    }],
            })(
              <DatePicker
                format={this.dateFormatNumber("studyLeaveReturnDocumentDate")}
                placeholder=""
                style={{ width: "100%" }}
                disabled={true}
              />
            )}
          </Form.Item> */}
          {/* <FromInput
            disabled={true}
            value={detailForm?.studyLeaveDetail[0].studyLeaveReturnDocumentDate ? changeFormatdate(detailForm?.studyLeaveDetail[0].studyLeaveReturnDocumentDate) : "-"}
            required={false}
            name={"studyLeaveReturnDocumentDate"}
            label="ลงวันที่เลขที่คำสั่งกลับ"
            mode={"text"}
          /> */}
        </Col>
      </Row>
    );
  }
}

Tab1.defaultProps = {
  autoFocus: false,
};

Tab1.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedTab1 = Form.create()(Tab1);

export default withApollo(WrappedTab1);
